var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MgsNextStepNavigationDefault',{attrs:{"portalId":this.$store.page.page.portal.id,"pageId":this.$store.page.page.id,"language":_vm.$store.ui.appCurrentLanguage,"country":_vm.$store.ui.appCurrentCountry,"editMode":_vm.$store.page.isInEditMode}})
}
var staticRenderFns = []

export { render, staticRenderFns }